/**
 * Représente les differents évènements émis par le composant CustomConnectionComponent.
 */
export enum ConnectionEvents {
    /**
     * La connexion a été selectionnée.
     */
    Selected = 1,
    /**
     * La connexion a été deselectionnée.
     */
    Unselected = 2,
}
